// extracted by mini-css-extract-plugin
export default {"dropdownItem":"StatusDropdownItem_dropdownItem__+irUZ","deleteDropdownItem":"StatusDropdownItem_deleteDropdownItem__1IM70"};